import { isTestEnv, initEnv } from '@tencent/pmd-tools/lib/env';
import { composeUrlQuery } from '@tencent/pmd-tools/lib/url/url';
import { post } from '@tencent/pmd-network';
import { getUrlPath } from 'src/local-logic/utils/url/url';

/*
 * Desc:
 * Date: 2023-09-14 18:18:05
 * cusperbi: Please set LastEditors
 * Email: cusperbi@tencent.com
 */
function gotoWebview(vuethis, path, isReplace = false, query) {
  const newPath = path.replace(/%/g, '%25');
  const hasQuery = typeof query === 'object' && query !== null && Object.keys(query).length > 0;
  if (vuethis.isMpWeixin) {
    let url = `${getUrlPath()}${newPath}`;

    if (hasQuery) {
      url = composeUrlQuery(url, query);
    }
    const webViewUrl = `/views/webview/webview?url=${encodeURIComponent(url)}`;
    if (isReplace) {
      uni.redirectTo({ url: webViewUrl });
    } else {
      uni.navigateTo({ url: webViewUrl });
    }
  } else {
    let purePath; let originQueryObj = {};
    if (path.indexOf('?') > -1) {
      purePath = path.substring(0, path.indexOf('?'));
      originQueryObj = getQueryObject(path);
    } else {
      purePath = path;
    }
    const paramObj = { path: purePath };
    paramObj.query = originQueryObj;
    if (hasQuery) {
      paramObj.query = {
        ...paramObj.query,
        query,
      };
    }
    if (isReplace) {
      uni.redirectTo({ url: path });
    } else {
      uni.navigateTo({ url: path });
    }
  }
}

function getQueryObject(url) {
  // 创建一个空对象来存储查询参数
  const queryObject = {};

  // 找到 '?' 的位置
  const questionMarkIndex = url.indexOf('?');
  if (questionMarkIndex !== -1) {
    // 获取查询字符串
    const queryString = url.substring(questionMarkIndex + 1);

    // 分割查询字符串为各个参数
    const pairs = queryString.split('&');

    // 遍历每个参数
    pairs.forEach((pair) => {
      // 分割键和值
      const [key, value] = pair.split('=');
      if (key) {
        // 解码并添加到对象中
        queryObject[decodeURIComponent(key)] = value ? decodeURIComponent(value) : '';
      }
    });
  }

  return queryObject;
}

/**
 * 授权引导 webview跳转电子流 传入code 打通登录态
 * @param {*} tThis 传入的vue this
 * @param {*} path 跳转的路由
 */
function authorizeWebview(tThis, path) {
  const env = initEnv();
  const newPath = path.replace(/%/g, '%25');
  post({
    url: '/pvpesport.cgi.commcgi.commcgi/BuildSSOCode',
  }).then((res) => {
    if (res.code) {
      let url = getUrl(newPath);
      const code = env.isQQ ? '' : res.code; // 电子流只有微信登录
      if (url.indexOf('?') > -1) {
        url = `${url}&mpcode=${code}`;
      } else {
        url = `${url}?mpcode=${code}`;
      }
      // 之前的webview页面没有处理页面带参数问题
      const webViewUrl = `/views/webview/webview?url=${encodeURIComponent(url)}`;
      if (tThis.isMPWeixin) {
        uni.navigateTo({ url: webViewUrl });
      } else {
        setTimeout(() => {
          window.location.href = url;
        }, 200);
      }
    }
  })
    .catch(() => {
    });
}

// 先改成预发布环境测试，上线前改回来
// 正式url = 'https://igame.qq.com/tip/igame-web/pvp-match-apply-mobile/#/';
// 预发布url = `https://test.igame.qq.com/tip/igame-web/pvp-match-apply-mobile/#/${newPath}&tip_debug_cgi_env=prod`;
// const interfaceURL =  isTestEnv()
//   ? url : url.indexOf('?') === -1 ? `${url}?tip_debug_cgi_env=prod`
//     : `${url}&tip_debug_cgi_env=prod`;

// return interfaceURL;

function getUrl(newPath) {
  const url = isTestEnv() ? `https://test.igame.qq.com/tip/igame-web/feature/order-band/pvp-match-apply-mobile/#/${newPath}`
    : `https://igame.qq.com/tip/igame-web/pvp-match-apply-mobile/#/${newPath}`;

  return url;
}

export  { gotoWebview, authorizeWebview };
